export default "__VITE_ASSET__DJwY3ZXh__"